(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brewing-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-brewing-hero-content]').forEach((el) => {
      if (prefersReducedMotion) {
        el.classList.add('is-visible');
        return;
      }
      requestAnimationFrame(() => {
        requestAnimationFrame(() => el.classList.add('is-visible'));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brewing-steps"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-brewing-steps-list]').forEach((list) => {
      const steps = list.querySelectorAll('.brewing-steps__step');

      if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        steps.forEach((step) => step.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );

      steps.forEach((step) => observer.observe(step));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["build-your-own-box"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-byo-app]').forEach((app) => {
      if (app.dataset.byoInitialized) return;
      app.dataset.byoInitialized = 'true';

      const required = parseInt(app.dataset.required, 10) || 9;
      const boxCount = parseInt(app.dataset.boxCount, 10) || Math.max(required - 1, 0);
      const counterTemplate = app.dataset.counterTemplate || ':count / :total selected';
      const hintIncompleteTemplate = app.dataset.hintIncomplete || '';
      const hintBoxReady = app.dataset.hintBoxReady || '';
      const hintComplete = app.dataset.hintComplete || '';
      const errorText = app.dataset.errorText || 'Something went wrong adding your box to the cart. Please try again.';
      const boxVariantId = app.dataset.boxVariantId;
      const boxAvailable = app.dataset.boxAvailable === 'true';
      const maxPerFlavor = parseInt(app.dataset.maxPerFlavor, 10) || 5;
      // Falls back to the section's per-flavour cap if a card is missing
      // its own data-max-qty.
      const getCardMax = (card) => {
        const max = parseInt(card.dataset.maxQty, 10);
        return Math.min(Number.isFinite(max) ? max : maxPerFlavor, maxPerFlavor);
      };

      const cards = Array.from(app.querySelectorAll('[data-byo-card]'));
      const counterEl = app.querySelector('[data-byo-counter]');
      const progressEl = app.querySelector('[data-byo-progress]');
      const hintEl = app.querySelector('[data-byo-hint]');
      const ctaEl = app.querySelector('[data-byo-cta]');
      const ctaLabelEl = app.querySelector('[data-byo-cta-label]');
      const errorEl = app.querySelector('[data-byo-error]');
      const summaryEl = app.querySelector('[data-byo-summary]');
      const summaryListEl = app.querySelector('[data-byo-summary-list]');
      const ctaDefaultLabel = ctaLabelEl ? ctaLabelEl.textContent : '';

      const state = new Map(cards.map((card) => [card, 0]));
      let isSubmitting = false;

      const getTotal = () => Array.from(state.values()).reduce((sum, qty) => sum + qty, 0);

      const render = () => {
        const total = getTotal();
        const remainingForBox = Math.max(boxCount - total, 0);

        counterEl.textContent = counterTemplate
          .replace(':count', total)
          .replace(':total', required);

        progressEl.style.width = `${Math.min((total / required) * 100, 100)}%`;

        cards.forEach((card) => {
          const qty = state.get(card);
          const isSelected = qty > 0;
          card.classList.toggle('is-selected', isSelected);

          const qtyEl = card.querySelector('[data-byo-qty]');
          const increaseBtn = card.querySelector('[data-byo-increase]');
          const decreaseBtn = card.querySelector('[data-byo-decrease]');

          if (qtyEl) qtyEl.textContent = String(qty);
          // A flavour can't go above its own cap (max_per_flavor, or less when sachet
          // stock is lower — 0 for sold out), and no flavour can push the
          // box total above what's required.
          if (increaseBtn) increaseBtn.disabled = qty >= getCardMax(card) || total >= required;
          if (decreaseBtn) decreaseBtn.disabled = qty === 0;
        });

        const isComplete = total === required;
        ctaEl.disabled = !isComplete || isSubmitting;

        if (isComplete) {
          hintEl.textContent = hintComplete;
        } else if (total >= boxCount) {
          hintEl.textContent = hintBoxReady;
        } else {
          hintEl.textContent = hintIncompleteTemplate.replace(':remaining', remainingForBox);
        }
        hintEl.classList.toggle('is-complete', isComplete);

        if (!isComplete && summaryEl) {
          summaryEl.hidden = true;
        }
        if (!isComplete && errorEl) {
          errorEl.hidden = true;
        }
      };

      cards.forEach((card) => {
        const increaseBtn = card.querySelector('[data-byo-increase]');
        const decreaseBtn = card.querySelector('[data-byo-decrease]');

        if (increaseBtn) {
          increaseBtn.addEventListener('click', () => {
            const qty = state.get(card);
            if (qty >= getCardMax(card) || getTotal() >= required) return;
            state.set(card, qty + 1);
            render();
          });
        }

        if (decreaseBtn) {
          decreaseBtn.addEventListener('click', () => {
            const qty = state.get(card);
            if (qty <= 0) return;
            state.set(card, qty - 1);
            render();
          });
        }
      });

      const buildSelections = () =>
        cards
          .map((card) => ({ title: card.dataset.flavorTitle, qty: state.get(card) }))
          .filter((selection) => selection.qty > 0);

      const showSummary = (selections) => {
        if (!summaryListEl) return;
        summaryListEl.innerHTML = '';
        selections.forEach(({ qty, title }) => {
          const li = document.createElement('li');
          li.textContent = `${qty} × ${title}`;
          summaryListEl.appendChild(li);
        });
        if (summaryEl) {
          summaryEl.hidden = false;
          summaryEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      };

      const showError = (message) => {
        if (!errorEl) return;
        errorEl.textContent = message;
        errorEl.hidden = false;
      };

      const setSubmitting = (submitting) => {
        isSubmitting = submitting;
        ctaEl.disabled = submitting || getTotal() !== required;
        if (ctaLabelEl) {
          ctaLabelEl.textContent = submitting ? '…' : ctaDefaultLabel;
        }
      };

      const addBoxToCart = async () => {
        const selections = buildSelections();
        const properties = {};
        selections.forEach(({ qty, title }) => {
          properties[title] = String(qty);
        });

        setSubmitting(true);
        if (errorEl) errorEl.hidden = true;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [
                {
                  id: boxVariantId,
                  quantity: 1,
                  properties,
                },
              ],
            }),
          });

          const data = await response.json();

          if (!response.ok) {
            throw new Error(data?.description || errorText);
          }

          window.location.href = '/cart';
        } catch (error) {
          setSubmitting(false);
          showError(error.message || errorText);
        }
      };

      if (ctaEl) {
        ctaEl.addEventListener('click', () => {
          if (getTotal() !== required || isSubmitting) return;

          const selections = buildSelections();

          if (!boxVariantId) {
            // Mixed Collection product not yet configured in the section
            // settings — show the local preview instead of attempting a
            // real cart submission.
            showSummary(selections);
            return;
          }

          if (!boxAvailable) {
            showError(errorText);
            return;
          }

          addBoxToCart();
        });
      }

      render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coffee-journey"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-journey-track]').forEach((track) => {
      const steps = track.querySelectorAll('.coffee-journey__step');

      if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        steps.forEach((step) => step.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.2 }
      );

      steps.forEach((step) => observer.observe(step));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-back-to-top"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const CONTROLS = 'button, input, select, textarea, [role="button"], a.button, .button';

    const init = (button) => {
      if (button.dataset.bttInitialized) return;
      button.dataset.bttInitialized = 'true';

      const threshold = parseInt(button.dataset.threshold, 10) || 500;
      const wrapper = document.querySelector('.page-wrapper');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let settleTimer;

      const scrollTop = () => Math.max(window.scrollY, wrapper ? wrapper.scrollTop : 0);

      // Shopify's privacy banner sits at the bottom of the viewport when shown.
      const updateLift = () => {
        const banner = document.getElementById('shopify-pc__banner');
        const rect = banner && banner.offsetParent !== null ? banner.getBoundingClientRect() : null;
        const lift = rect && rect.height > 0 && rect.top < window.innerHeight ? window.innerHeight - rect.top : 0;
        button.style.setProperty('--btt-lift', `${Math.max(0, Math.round(lift))}px`);
      };

      // Is any button/form control (other than this one) under the button's footprint?
      const obstructs = (shift) => {
        // Layout box of the fixed button, ignoring any in-progress transform.
        const left = button.offsetLeft;
        const top = button.offsetTop;
        const right = left + button.offsetWidth;
        const bottom = top + button.offsetHeight;
        const inset = 4;
        const points = [
          [left + inset, top + inset],
          [right - inset, top + inset],
          [left + inset, bottom - inset],
          [right - inset, bottom - inset],
          [(left + right) / 2, (top + bottom) / 2],
        ];
        return points.some(([x, y]) =>
          document
            .elementsFromPoint(x, y + shift)
            .some((el) => !button.contains(el) && el.closest(CONTROLS))
        );
      };

      // After scrolling settles, step upward out of the way of a control, or hide.
      const avoidControls = () => {
        button.classList.remove('is-obstructing');
        button.style.setProperty('--btt-shift', '0px');
        if (!button.classList.contains('is-visible')) return;
        const step = button.offsetHeight + 12;
        for (const shift of [0, -step, -2 * step]) {
          if (!obstructs(shift)) {
            button.style.setProperty('--btt-shift', `${shift}px`);
            return;
          }
        }
        button.classList.add('is-obstructing');
      };

      const update = () => {
        button.classList.toggle('is-visible', scrollTop() > threshold);
        clearTimeout(settleTimer);
        settleTimer = setTimeout(() => {
          updateLift();
          avoidControls();
        }, 140);
      };

      button.addEventListener('click', () => {
        const behavior = reducedMotion.matches ? 'instant' : 'smooth';
        if (wrapper) wrapper.scrollTo({ top: 0, behavior });
        window.scrollTo({ top: 0, behavior });
        // The button hides at the top, so hand focus to the start of the page.
        const start =
          document.querySelector('[data-shop-collection-nav] a') || document.querySelector('main');
        if (start) {
          if (!start.matches('a, button') && !start.hasAttribute('tabindex')) start.setAttribute('tabindex', '-1');
          start.focus({ preventScroll: true });
        }
      });

      window.addEventListener('scroll', update, { passive: true });
      if (wrapper) wrapper.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    };

    document.querySelectorAll('[data-shop-back-to-top]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-shop-back-to-top]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-collection-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const findTarget = (key) => {
      const markers = document.querySelectorAll(`[data-shop-nav-target="${key}"]`);
      for (const el of markers) {
        if (el.getClientRects().length > 0) return el;
      }
      return document.getElementById(
        key === 'one-flavor' ? 'shop-one-flavor-collection' : 'shop-build-your-own-box'
      );
    };

    const init = (nav) => {
      if (nav.dataset.scnInitialized) return;
      nav.dataset.scnInitialized = 'true';

      const links = Array.from(nav.querySelectorAll('[data-shop-nav-link]'));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      links.forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = findTarget(link.dataset.shopNavLink);
          if (!target) return;
          event.preventDefault();
          // 'instant', not 'auto': base.css sets scroll-behavior: smooth, which 'auto' would inherit.
          target.scrollIntoView({ behavior: reducedMotion.matches ? 'instant' : 'smooth', block: 'start' });
          // Move focus for keyboard and screen-reader users without a second jump.
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        });
      });

      if (!('IntersectionObserver' in window)) return;
      const pairs = links
        .map((link) => ({ link, target: findTarget(link.dataset.shopNavLink) }))
        .filter((pair) => pair.target);
      const visible = new Set();
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) visible.add(entry.target);
            else visible.delete(entry.target);
          });
          // The topmost section in view is the current one.
          let current = null;
          pairs.forEach((pair) => {
            if (!visible.has(pair.target)) return;
            if (!current || pair.target.getBoundingClientRect().top < current.target.getBoundingClientRect().top) {
              current = pair;
            }
          });
          pairs.forEach((pair) => {
            if (pair === current) pair.link.setAttribute('aria-current', 'true');
            else pair.link.removeAttribute('aria-current');
          });
        },
        { rootMargin: '-30% 0px -50% 0px' }
      );
      pairs.forEach((pair) => observer.observe(pair.target));
    };

    document.querySelectorAll('[data-shop-collection-nav]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-shop-collection-nav]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-choose"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-why-choose-grid]').forEach((grid) => {
      const items = grid.querySelectorAll('.why-choose__item');

      if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.2 }
      );

      items.forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
